import React from 'react';
import styles from './UIGameEndFooter.module.scss';
import { T } from '@colonist/ui';
import { UIGameButton } from '../../../common/UIGameButton/index.ts';
import { useUIGameEndContext } from '../../../contexts/UIGameEndContext.tsx';
import { GameTypeEnum, ModeSettingEnum } from '@colonist/types';
import clsx from 'clsx';
import { FADE_IN_ANIMATION_DELAYS } from '../constants.ts';
import { FadeInContainer } from '../../../common/FadeInContainer/index.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useIsReplay } from '../../../store/selectors/useIsReplay.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
var EndGameButtonTypes = /*#__PURE__*/ function(EndGameButtonTypes) {
    EndGameButtonTypes[EndGameButtonTypes["Rematch"] = 0] = "Rematch";
    EndGameButtonTypes[EndGameButtonTypes["Lobby"] = 1] = "Lobby";
    EndGameButtonTypes[EndGameButtonTypes["PlayAgain"] = 2] = "PlayAgain";
    EndGameButtonTypes[EndGameButtonTypes["NextLevel"] = 3] = "NextLevel";
    EndGameButtonTypes[EndGameButtonTypes["Retry"] = 4] = "Retry";
    return EndGameButtonTypes;
}(EndGameButtonTypes || {});
function getEndGameRightButtonType(isCampaign, isMatchmakingGame, isBotGame, isWonByHuman) {
    if (isMatchmakingGame) return 2;
    if (isBotGame) return 2;
    if (isCampaign) return isWonByHuman ? 3 : 4;
    return 0;
}
export function UIGameEndFooter({ disableAnimation }) {
    const gameSettings = useGameStore((state)=>state.gameSettings);
    const userStates = useGameStore((state)=>state.gameUserStates.userStates);
    const isReplay = useIsReplay();
    const isAfterLiveGame = useGameStore((state)=>state.gameEnd.isAfterLiveGame);
    const { playerValidators } = usePlayerValidators();
    const { onClickRematch, onClickPlayAgain, onClickRetryBeginnerMode, onClickNextLevelBeginnerMode, onClickHome, numberOfPlayersJoinedRematch, playersByRank, isPlayerHasRankedState } = useUIGameEndContext();
    const isMyUserIdPlaying = playerValidators.some((player)=>player.isCurrentUser);
    const renderRightButton = ()=>{
        if (!isMyUserIdPlaying) return null;
        if (!(isAfterLiveGame || !isReplay)) return null;
        const isCampaign = gameSettings.modeSetting == ModeSettingEnum.BeginnerModeClassic4P;
        const isMatchmakingGame = gameSettings.gameType == GameTypeEnum.MatchmakingGame || gameSettings.gameType == GameTypeEnum.MatchmakingGameRanked;
        const isBotGame = gameSettings.gameType == GameTypeEnum.BotGame;
        const winningPlayerColor = playersByRank[0].color;
        const winningUser = userStates.find((userState)=>userState.selectedColor === winningPlayerColor);
        const isWonByHuman = (winningUser === null || winningUser === void 0 ? void 0 : winningUser.isBot) === false;
        const rightButton = getEndGameRightButtonType(isCampaign, isMatchmakingGame, isBotGame, isWonByHuman);
        let translation = {
            key: 'strings:game.endGame.footer.continue'
        };
        let onClickAction;
        switch(rightButton){
            case 0:
                translation = numberOfPlayersJoinedRematch ? {
                    key: 'strings:game.endGame.footer.playersJoined',
                    options: {
                        playerCount: numberOfPlayersJoinedRematch,
                        maxPlayerCount: gameSettings.maxPlayers
                    }
                } : {
                    key: 'strings:game.endGame.footer.rematch'
                };
                onClickAction = onClickRematch;
                break;
            case 2:
                translation = {
                    key: 'strings:game.endGame.footer.play'
                };
                onClickAction = onClickPlayAgain;
                break;
            case 4:
                translation = {
                    key: 'strings:game.endGame.footer.retry'
                };
                onClickAction = onClickRetryBeginnerMode;
                break;
            case 3:
                translation = {
                    key: 'strings:game.endGame.footer.nextLevel'
                };
                onClickAction = onClickNextLevelBeginnerMode;
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ React.createElement(UIGameButton, {
            className: styles.button,
            onClick: onClickAction
        }, /*#__PURE__*/ React.createElement(T, {
            id: translation
        }));
    };
    return /*#__PURE__*/ React.createElement(FadeInContainer, {
        animationDelayMs: isPlayerHasRankedState && !isReplay ? FADE_IN_ANIMATION_DELAYS.footerRankedGame : FADE_IN_ANIMATION_DELAYS.footer,
        animationDurationMs: FADE_IN_ANIMATION_DELAYS.transitionDuration,
        className: styles.footerContainer,
        disableAnimation: disableAnimation
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.buttons)
    }, /*#__PURE__*/ React.createElement(UIGameButton, {
        className: styles.button,
        onClick: onClickHome,
        variant: "dark"
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.footer.home'
        }
    })), renderRightButton()));
}
